import { defineStore } from 'pinia'

export const useProjectMobileHeaderStore = defineStore('projectMobileHeader', {
  state: () => ({
    title: '' as string,
  }),

  actions: {
    setTitle(title: string) {
      this.title = title
    },

    clear() {
      this.title = ''
    },
  },
})
